const labraApiHostPrefixByEnv = {
  qa: 'qa.',
  q1: 'qa.',
  q2: 'qa.',
  dev: 'qa.',
  development: 'qa.',
  local: 'qa.',
  stg: 'stg.',
  staging: 'stg.',
  prd: '',
  prod: '',
} as const

export const getServiceUrl = (service: string, env: string) => {
  const sub =
    labraApiHostPrefixByEnv[env as keyof typeof labraApiHostPrefixByEnv] ?? ''
  return `https://${sub}api.labra.io/${service}`
}
